import React from "react";
import PropTypes from "prop-types";

import CsLineIcons from "../../cs-line-icons";

const formatRelativeTime = (value) => {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";

    const elapsed = Math.max(0, Date.now() - date.getTime());
    const minute = 60 * 1000;
    const hour = 60 * minute;
    const day = 24 * hour;

    if (elapsed < minute) return "now";
    if (elapsed < hour) return `${Math.floor(elapsed / minute)} min ago`;
    if (elapsed < day) return `${Math.floor(elapsed / hour)} hr ago`;
    const days = Math.floor(elapsed / day);
    return `${days} ${days === 1 ? "day" : "days"} ago`;
};

const styleClass = (style) => {
    switch (style) {
        case "UR":
            return "is-urgent";
        case "LO":
            return "is-low";
        case "3D":
            return "is-activity";
        default:
            return "is-default";
    }
};

const NotificationItem = ({
    activeDate,
    description,
    id,
    onRead,
    style,
    title,
}) => (
    <li className="notification-item">
        <div className={`notification-item-icon ${styleClass(style)}`} aria-hidden="true">
            <span className="notification-item-dot" />
            <CsLineIcons icon="form-check" size="16" />
        </div>
        <div className="notification-item-copy">
            {title ? <div className="notification-item-title">{title}</div> : null}
            <div className="notification-item-description">{description}</div>
        </div>
        <div className="notification-item-meta">
            <span>{formatRelativeTime(activeDate)}</span>
            <button type="button" onClick={() => onRead(id)}>Mark read</button>
        </div>
    </li>
);

NotificationItem.defaultProps = {
    activeDate: null,
    description: "",
    style: null,
    title: "",
};

NotificationItem.propTypes = {
    activeDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    description: PropTypes.string,
    id: PropTypes.string.isRequired,
    onRead: PropTypes.func.isRequired,
    style: PropTypes.string,
    title: PropTypes.string,
};

export { formatRelativeTime, styleClass };
export default NotificationItem;
